import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ImageSelector } from '../../common/ImageSelector';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ImageSelectorWidget = (props) => {
    const component = useMemo(() => props.user ? (_jsx(ImageSelector, { imageContainingVob: props.user, transactionFunctions: props.transactionFunctions, userFunctions: props.userFunctions })) : (_jsx(_Fragment, {})), [props.user]);
    return {
        name: 'ImageSelector',
        category: 'common',
        component,
    };
};
